import {Component, computed, inject} from '@angular/core';
import {TableModule} from 'primeng/table';
import {TranslocoDirective} from '@jsverse/transloco';
import {BackgroundCardComponent} from '../../../../../shared/components/titled-background-card/background-card.component';
import {Button} from 'primeng/button';
import {UserInvitationTemplateDialogComponent} from '../user-invitation-template-dialog/user-invitation-template-dialog.component';
import {ProjectUserService} from '../project-user.service';
import {UserInvitationTemplateDialogService} from '../user-invitation-template-dialog/user-invitation-template-dialog.service';
import {ActivatedRoute} from '@angular/router';
import {TranslatedOption} from '../../../../../shared/services/enum-translation-mapper.service';
import {ProjectDetailResponse, ProjectRoleType} from '@frontend/shared-api';
import {LoadingComponent} from '../../../../../shared/components/loading/loading.component';

@Component({
  selector: 'app-user-invitation-template-list',
  imports: [
    TableModule,
    BackgroundCardComponent,
    Button,
    UserInvitationTemplateDialogComponent,
    TranslocoDirective,
    LoadingComponent,
  ],
  templateUrl: './user-invitation-template-list.component.html',
})
export class UserInvitationTemplateListComponent {
  protected readonly projectUserService = inject(ProjectUserService);
  private readonly dialogService = inject(UserInvitationTemplateDialogService);
  private readonly route = inject(ActivatedRoute);

  readonly project = this.route.snapshot.data['project'] as ProjectDetailResponse;

  readonly rolesList = computed(() => this.projectUserService.rolesList());

  onEditTemplateClick(role: TranslatedOption<ProjectRoleType>) {
    this.dialogService.openDialog(role);
  }
}
